import { SpinnerMonoIndicators } from '@clearkit/icons';

export const Spinner = () => (
  <SpinnerMonoIndicators className="w-6 h-6 text-blue-500" />
);
